export default __webpack_public_path__ + "static/media/Escadas.5f6c1be5.svg";